import "./Aboutus.css";
import placeholderImg from "../assets/placeholder-image.png";
import { useNavigate, useLocation } from "react-router-dom";   // ✅ ADD THIS

import img1 from "../assets/environmental-sustainability.jpg";
import img2 from "../assets/education&child-development.jpg";
import img3 from "../assets/skill-development-and-youth-empowerment.jpg";
import img4 from "../assets/community-development.jpg";
import { useEffect } from "react";

function Aboutus() {
const navigate = useNavigate();
const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [location]);

  return (
    <>
      <section className="about">
        <div className="about-container">
          <div className="about-text">
            <h2>Who We Are</h2>
            <p>
              Dhara Foundation was born from a deep belief that growth should not 
              be measured only in profits, but in the positive impact we create for society.
            </p>
          </div>

          <div className="about-image">
            <img src={placeholderImg} alt="Who We Are" />
          </div>
        </div>
      </section>


{/* Vision & Mission */}

<section className="vision-mission">
  <div className="vision-mission-container">

    {/* Mission Card 
    <div className="vm-card">
      <h2>Our Mission</h2>

      <p>
        Our mission is to empower communities through
        education, healthcare, environmental sustainability,
        and social development initiatives.
      </p>
    </div>*/}

    {/* Vision Card 
    <div className="vm-card" id="vision">
      <h2>Our Vision</h2>

      <p>
       To design, implement, and monitor high-impact CSR initiatives in environmental sustainability, 
       child education, and community development, ensuring transparent fund use, measurable outcomes, 
       and enduring self-reliance through expert execution and strong local partnerships.
      </p>
    </div>*/}

  </div>
</section>

      <section className="what">
        <div className="what-container">

          <div className="what-text">
            <h2 className="what-title">What We Do</h2>
            <p className="what-subtitle">
              Four core areas drive our mission forward
            </p>
          </div>

          <div className="what-images">
            <img src={img1} alt="environmental-sustainability" />
            <img src={img2} alt="education&child-development" />
            <img src={img3} alt="skill-development-and-youth-empowerment" />
            <img src={img4} alt="community-development" />
          </div>

          <div className="what-button">
            <button onClick={() => navigate("/our-csr")}>
              View All
            </button>
          </div>

        </div>
      </section>
    </>
  );
}

export default Aboutus;